import type { OrderType } from "../pages/Order/types"

type OrderStatus = OrderType["status"]
type BadgeVariant =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "neutral"
  | "purple"
  | "blue"

interface OrderStatusDisplay {
  label: string
  variant: BadgeVariant
}

const statusMap: Record<OrderStatus, OrderStatusDisplay> = {
  DRAFT: { label: "Draft", variant: "warning" },
  CLOSING: { label: "At Table", variant: "blue" },
  UPLOADING: { label: "Uploading", variant: "purple" },
  FINALIZING: { label: "Finalizing", variant: "purple" },
  COMPLETED: { label: "Completed", variant: "success" },
  CANCELED: { label: "Cancelled", variant: "neutral" },
}

export function useOrderStatus() {
  const getStatusDisplay = (status: OrderStatus): OrderStatusDisplay => {
    return statusMap[status]
  }

  return { getStatusDisplay }
}
